function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Text from './Text'; // NOTE: PLEASE DO NOT EDIT THIS FILE!
// it's autogenerated by generateTextComponents.js

export var Display96 = function Display96(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "display96"
  }));
};
export var Display72 = function Display72(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "display72"
  }));
};
export var Display60 = function Display60(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "display60"
  }));
};
export var Display52 = function Display52(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "display52"
  }));
};
export var Display44 = function Display44(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "display44"
  }));
};
export var Title36 = function Title36(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "title36"
  }));
};
export var Title32 = function Title32(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "title32"
  }));
};
export var Title28 = function Title28(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "title28"
  }));
};
export var Title24 = function Title24(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "title24"
  }));
};
export var Title20 = function Title20(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "title20"
  }));
};
export var Label18 = function Label18(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "label18"
  }));
};
export var Label16 = function Label16(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "label16"
  }));
};
export var Label14 = function Label14(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "label14"
  }));
};
export var Label12 = function Label12(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "label12"
  }));
};
export var Body18 = function Body18(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "body18"
  }));
};
export var Body16 = function Body16(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "body16"
  }));
};
export var Body14 = function Body14(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "body14"
  }));
};
export var Body12 = function Body12(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    type: "body12"
  }));
};